'use client';

import { useState } from 'react';
import type PageType from '@alltrails/amplitude/enums/PageType';
import FrequentlyAskedQuestion from '../FrequentlyAskedQuestion/FrequentlyAskedQuestion';
import ShowMoreButton from '../ShowMoreButton/ShowMoreButton';

type FaqEntry = {
  question: string;
  answer: React.ReactNode;
  key: string;
};

type Props = {
  faqEntries: FaqEntry[];
  id: number;
  isBot?: boolean;
  pageType: PageType;
};

const FAQ_LIMIT = 6;

export default function ShowMoreFaqs({ faqEntries, id, isBot, pageType }: Props) {
  const [isExpanded, setIsExpanded] = useState(false);
  const hasMoreFaqs = faqEntries.length > FAQ_LIMIT;
  const showLimitedExperience = hasMoreFaqs && !isBot;

  const displayFaqs = isExpanded || !showLimitedExperience ? faqEntries : faqEntries.slice(0, FAQ_LIMIT);

  return (
    <>
      {displayFaqs.map(faq => (
        <FrequentlyAskedQuestion
          id={id}
          question={faq.question}
          answer={faq.answer}
          key={faq.key}
          pageType={pageType}
          shouldRenderExpanded={isBot || displayFaqs.length === 1}
        />
      ))}
      {showLimitedExperience && (
        <ShowMoreButton
          isExpanded={isExpanded}
          onToggle={() => setIsExpanded(!isExpanded)}
          testId="show-more-faqs"
        />
      )}
    </>
  );
}
